import React, { useEffect, useState } from "react";
import moment from "moment";
import { Doughnut } from "react-chartjs-2";
import { chartColors } from "../../../components/form/debtPayOff/components/color";
import insuranceIcon from "../../../assets/images/insurance.png";
import endingInsuranceIcon from "../../../assets/images/modules.png";
import highInsuranceIcon from "../../../assets/images/performance.png";
import "../InsuranceDashboard.css";
import getFAClientName from "../../../helpers/getFAClientName";

export const InsuranceReport = ({stats, totalPremium}) => {
  const [clientName, setClientName] = useState("");
  const dataDonught = {
    labels: ["car", "dental", "businees"],
    datasets: [
      {
        label: "# of Votes",
        data: ["234", "345", "456"],
        backgroundColor: chartColors,
        borderColor: chartColors,
        borderWidth: 1,
      },
    ],
    text: `${"20000"}`,
  };

  const insuranceReportCards = [
    {
      id: 1,
      name: "Policies Ending Soon",
      insuranceNameStart:"Honda Auto Insurance",
      insuranceNameEnd:"Family Health Insurance",
      thisYear:
        2344 &&
        2344 ?
        parseFloat(2344)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      thisMonth:
      2344 &&
      2344 ?
        parseFloat(2344)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      icon: endingInsuranceIcon,
    },
    {
      id: 2,
      name: "Highest Monthly Premium",
      insuranceNameStart:"Honda Auto Insurance",
      insuranceNameEnd:"Family Health Insurance",
      thisYear:
      2344 &&
      2344 ?
        parseFloat(2344)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      thisMonth:
      2344 &&
      2344 ?
        parseFloat(2344)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0,
      icon: highInsuranceIcon,
    },
  ];

  useEffect(()=>{
    const name = getFAClientName();
    if (name) setClientName(name);
  },[])
  return (
    <React.Fragment>
      <div className="incomeCard1">
        <h3 className="Reportheading">Insurance</h3>
        <div className="incomeRow">
          <div>
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "48%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={insuranceIcon}
                  alt="insuranceIcon"
                />
              </div>
              <div style={{ textAlign: "center", width: "49%" }}>
                <div className="incomeCardConatiner">
                  <h3
                    className="Reportheading"
                    style={{
                      fontSize: "16px",
                      fontWeight: "900",
                    }}
                  >
                  Monthly Premium
                  </h3>
                  <h3 className="Reportheading" style={{ fontWeight: "700" }}>
                    $
                    {totalPremium &&
                      totalPremium ?
                      totalPremium
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") :0}
                  </h3>
                </div>
              </div>
            </div>
            {/*<h3 className="Reportheading">Synopsis: </h3>
            <p className="reportPara">
              Gross Income, Adjusted Gross Income, Modified Adjusted Gross
              Income, Passive or Earned
            </p> */}
          </div>
          <div>
            <div className="reportrow">
              <div className="reportrowData">
                <span className="reportTitle"> Client Name</span>
                <span className="reportsubTitle">
                {clientName || localStorage.getItem("User") || ""}
                </span>
              </div>
              <div className="reportrowData" style={{alignItems:"end"}}>
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {insuranceReportCards &&
        insuranceReportCards.map((item, index) => (
          <div className="incomeCard2" key={index}>
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <h3 className="incomeReportMainHaeding" style={{textAlign:"center", width:"50%"}}>{item.name}</h3>

              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "35%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={item.icon}
                  alt="incomeIcon"
                />
              </div>
            </div>
            <div className="incomeRow">
              <div>
                <div className="IncomeRowMonth">
                  <span className="IncomeRowMonthHeading">{item.insuranceNameStart}</span>
                  <span className="IncomeRowMonthValue">${item.thisMonth}</span>
                </div>
                <div className="IncomeRowMonth" style={{ marginTop: "1rem" }}>
                  <span className="IncomeRowMonthHeading">{item.insuranceNameEnd}</span>
                  <span className="IncomeRowMonthValue"> ${item.thisYear}</span>
                </div>
              </div>
            </div>
          </div>
        ))} */}
        <div className="incomeCard2">
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <h3 className="incomeReportMainHaeding" style={{textAlign:"center", width:"50%"}}>Policies Ending Soon</h3>

              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "35%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={endingInsuranceIcon}
                  alt="incomeIcon"
                />
              </div>
            </div>
            <div className="incomeRow">
              <div>
                {stats && stats.nearestPolicyEndDates && stats.nearestPolicyEndDates.map((item, index) => (
                  <div className="IncomeRowMonth" style={{ marginTop: "1rem" }} key={index}>
                    <span className="IncomeRowMonthHeading">{item.policy_name}</span>
                    <span className="IncomeRowMonthValue">{item.premium_value ? moment(item.policy_end_date).format("MMM DD, YYYY") : "N/A"}</span>
                  </div>
                )) 
                }
                
              </div>
            </div>
          </div>
        <div className="incomeCard2">
            <div className="budget-home-icon-container" style={{ gap: "4px" }}>
              <h3 className="incomeReportMainHaeding" style={{textAlign:"center", width:"50%"}}>Highest Monthly Premium</h3>

              <div
                className="asset-home-icon"
                style={{ textAlign: "center", width: "35%" }}
              >
                <img
                  style={{ width: "100%", minWidth: "100px" }}
                  src={highInsuranceIcon}
                  alt="incomeIcon"
                />
              </div>
            </div>
            <div className="incomeRow">
              <div>
                {stats && stats.topPremiums && stats.topPremiums.map((item, index) => (
                  <div className="IncomeRowMonth" style={{ marginTop: "1rem" }} key={index}>
                    <span className="IncomeRowMonthHeading">{item.policy_name}</span>
                    <span className="IncomeRowMonthValue">${item.premium_value ? item.premium_value.toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
      {/*<div className="insuranceCard2">
        <h1 className="liablitycardheading">Monthly Insurance Premium</h1>
        <div style={{ marginTop: "1rem", display: "flex" }}>
          <Doughnut
            data={dataDonught}
            options={{
              cutoutPercentage: 70,
              legend: {
                display: true,
                position: "right",
              },
            }}
          />
        </div>
      </div> */}
    </React.Fragment>
  );
};
